import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { Zap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-24 pb-16 overflow-hidden" data-id="element-125">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-126" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-127">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-129">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 text-amber-500 text-sm font-medium mb-6 border border-amber-500/20" data-id="element-130">
              <Zap className="w-4 h-4" data-id="element-131" />
              <span data-id="element-132">Sistema probado sin código</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight" data-id="element-133">
              IA para Dueños de Negocios:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-134">
                Automatiza en 48 Horas
              </span>
            </h1>

            <h2 className="text-xl md:text-2xl text-gray-300 font-medium mb-8 leading-relaxed" data-id="element-135">
              Libera tu tiempo y transforma tu negocio con IA, sin
              complicaciones técnicas
            </h2>

            <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-136">
              Te has pasado horas haciendo las mismas tareas una y otra vez:
              responder mensajes de clientes, enviar correos, organizar pedidos.
              Sabes que la IA podría ayudarte, pero cada solución que encuentras
              parece diseñada para expertos en tecnología. ¿Y si pudieras
              implementar automatizaciones en tu negocio en solo dos días, sin
              tener que aprender a programar?
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-137">
              <CTAButton className="w-full sm:w-auto" onClick={() => {
              document.getElementById('cta-final')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-138">
                Descargar eBook Ahora
              </CTAButton>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:ml-auto" data-id="element-139">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/20 to-transparent rounded-3xl blur-3xl" data-id="element-140" />
            <img src="https://cdn.magicpatterns.com/uploads/nQBx5RSE8rdAh5XPPZ4qp1/Imagen_Producto.png" alt="eBook IA para Dueños de Negocio" className="relative z-10 w-full max-w-md mx-auto lg:max-w-full drop-shadow-2xl rounded-2xl" data-id="element-141" />
          </motion.div>
        </div>
      </div>
    </section>;
}